import { io } from "socket.io-client";
import { getToken } from "./auth";

let socket = null;

export const getSocket = () => {
  if (!socket) {
    const baseURL = process.env.REACT_APP_BASE_URL || "";
    const token = getToken();
    socket = io(baseURL, {
      withCredentials: true,
      autoConnect: false,
      auth: { token }, // sent to server middleware for JWT verification
    });
  }
  return socket;
};

export const connectSocket = () => {
  const token = getToken();
  if (!token) return;
  const s = getSocket();
  // Refresh auth token in case it changed since socket was created
  s.auth = { token };
  if (!s.connected) {
    s.connect();
  }
};

export const disconnectSocket = () => {
  if (socket?.connected) socket.disconnect();
};
